<template>
  <div class="mobile_vote">
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> 请投票 </span>
      <div class="mobile_head_right">
        <a @click="refresh()">
          <i class="el-icon-refresh-right"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_bar" ref="mobileVoteBar">
      <div class="mobile_bar_main">
        <div class="mobile_bar_title">
          {{ voteInfo.VoteName }}
        </div>
        <div class="mobile_bar_tips">
          <span> 共：{{ voteInfo.ProjectTotalNum }} </span>
        </div>
      </div>
    </div>
    <div class="mobile_vote_main" :style="voteMainStyle">
      <transition-group name="list-complete" tag="div">
        <div
          class="mobile_project_box list-complete-item"
          v-for="item in voteInfo.VoteProjectList"
          :key="item.VoteProjectID"
        >
          <div class="project_item">
            <div class="project_title">
              {{ item.Sort }}.{{ item.VoteProjectName }}
            </div>
          </div>
          <div class="project_item">
            <i class="el-icon-s-opportunity icon_left icon_primary"></i>
            <div class="content">
              {{ item.VoteProjectRemark }}
            </div>
            <a
              @click="
                item.IsShowAdditionalRemark = !item.IsShowAdditionalRemark
              "
            >
              <i
                class="el-icon-caret-bottom icon_right icon_primary"
                :style="
                  item.IsShowAdditionalRemark
                    ? 'transform: rotate(-180deg);transition: all .5s'
                    : 'transform: rotate(0deg);transition: all .5s'
                "
              ></i>
            </a>
            <div class="rule_detaile_score">
              <el-input
                type="tel"
                class="vote_sort"
                size="mini"
                v-model="item.VoteSort"
                @focus="voteSort_focus(item)"
                @blur="voteSort_blur(item)"
              ></el-input>
            </div>
          </div>
          <div class="project_item" v-show="item.IsShowAdditionalRemark">
            <i
              class="el-icon-s-opportunity icon_left icon_warning"
              v-show="item.VoteProjectAdditionalRemark"
            ></i>
            <div
              class="content"
              v-html="item.VoteProjectAdditionalRemark"
            ></div>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="mobile_vote_operate_box" v-show="isShowOperateBox">
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.VoteSubmitConfig.isShow && !voteInfo.IsSubmit"
        :disabled="
          voteInfo.Status !== 1 ||
          voteInfo.IsSubmit !== 0 ||
          !voteInfo.IsVoteAllow
        "
        @click="submitVote()"
      >
        {{ voteInfo.VoteSubmitConfig.textValue }}
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="!voteInfo.IsSubmit"
        @click="openPreview()"
      >
        预览
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="
          voteInfo.CanSeeResult && voteInfo.IsSubmit && voteInfo.Status === 3
        "
        @click="openResult()"
      >
        查看结果
      </el-button>
    </div>
    <el-drawer
      :visible.sync="showPreview"
      direction="rtl"
      size="100%"
      :show-close="false"
      :withHeader="false"
    >
      <div class="mobile_vote_head">
        <div class="mobile_head_left">
          <a @click="previewGoBack()">
            <i class="el-icon-arrow-left"></i>
          </a>
        </div>
        <span class="mobile_head_desc"> 投票预览 </span>
        <div class="mobile_head_right">
          <a @click="refreshPreview()">
            <i class="el-icon-refresh-right"></i>
          </a>
        </div>
      </div>
      <div class="mobile_vote_bar" ref="mobileVotePreviewBar">
        <div class="mobile_bar_main">
          <div class="mobile_bar_title">
            {{ voteInfoPreview.VoteName }}
          </div>
          <div class="mobile_bar_tips">
            <span> 共：{{ voteInfoPreview.ProjectTotalNum }} </span>
          </div>
        </div>
      </div>
      <div class="mobile_vote_main" :style="votePreviewMainStyle">
        <div
          class="mobile_project_box"
          v-for="(project, index) in voteInfoPreview.VoteProjectList"
          :key="index"
        >
          <div class="project_item">
            <div class="project_title">
              {{ index + 1 }}、{{ project.VoteProjectName }}
            </div>
          </div>
          <div class="project_item">
            <i class="el-icon-s-opportunity icon_left icon_primary"></i>
            <div class="content">
              {{ project.VoteProjectRemark }}
            </div>
            <a
              @click="
                project.IsShowAdditionalRemark = !project.IsShowAdditionalRemark
              "
            >
              <i
                class="el-icon-caret-bottom icon_right icon_primary"
                :style="
                  project.IsShowAdditionalRemark
                    ? 'transform: rotate(-180deg);transition: all .5s'
                    : 'transform: rotate(0deg);transition: all .5s'
                "
              ></i>
            </a>
          </div>
          <div class="project_item" v-show="project.IsShowAdditionalRemark">
            <i
              class="el-icon-s-opportunity icon_left icon_warning"
              v-show="project.VoteProjectAdditionalRemark"
            ></i>
            <div
              class="content"
              v-html="project.VoteProjectAdditionalRemark"
            ></div>
          </div>
          <div class="project_item">
            <div class="font_primary">当前排序：{{ project.VoteSort }}</div>
            <div class="text_right">原序号：{{ project.Sort }}</div>
          </div>
        </div>
      </div>
      <div class="mobile_vote_operate_box">
        <el-button
          type="primary"
          size="medium"
          class="operate_btn"
          @click="previewGoBack()"
        >
          {{ voteInfo.IsSubmit ? '返回列表' : '返回投票' }}
        </el-button>
        <el-button
          type="primary"
          size="medium"
          class="operate_btn"
          v-if="
            voteInfo.CanSeeResult && voteInfo.IsSubmit && voteInfo.Status === 3
          "
          @click="openResult()"
        >
          查看结果
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import voteApi from '../../api/mobileVote/vote'
export default {
  data () {
    return {
      voteMainStyle: {
        marginTop: '65px'
      },
      votePreviewMainStyle: {
        marginTop: '65px'
      },
      voteInfo: {
        VoteProjectList: [],
        VoteSubmitConfig: {},
        VoteResetConfig: {}
      },
      showPreview: false,
      voteInfoPreview: {
        VoteProjectList: [],
        VoteSubmitConfig: {},
        VoteResetConfig: {}
      },
      isShowOperateBox: true
    }
  },
  methods: {
    goBack: function () {
      if (this.voteInfo.IsSubmit || this.voteInfo.Status === 3) {
        this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
      } else {
        this.saveVote('goBack')
      }
    },
    refresh: function () {
      if (this.voteInfo.IsSubmit) {
        this.getShortlistedVoteInfo()
      } else {
        this.saveVote('refresh')
      }
    },
    getSortVoteInfo: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteApi.getSortVoteInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteInfo = data
        _this.voteInfo.VoteProjectList = _this.sortByKey(_this.voteInfo.VoteProjectList, 'VoteSort')
        _this.voteInfo.VoteProjectList.forEach(item => {
          _this.$set(item, 'IsShowAdditionalRemark', false)
          item.VoteSort_temp = item.VoteSort
        })
        if (_this.voteInfo.IsSubmit) {
          _this.openPreview()
        }
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    // 数组对象方法排序
    sortByKey: function (array, key) {
      return array.sort(function (a, b) {
        var x = a[key]
        var y = b[key]
        return ((x < y) ? -1 : (x > y) ? 1 : 0)
      })
    },
    voteSort_focus: function (item) {
      item.VoteSort_temp = parseInt(item.VoteSort)
      item.VoteSort = undefined
      this.isShowOperateBox = false
    },
    voteSort_blur: function (item) {
      const _this = this
      _this.isShowOperateBox = true
      if (!item.VoteSort) {
        item.VoteSort = parseInt(item.VoteSort_temp)
      } else {
        item.VoteSort = parseInt(item.VoteSort)
        if (item.VoteSort > item.VoteSort_temp) {
          const projectTemp = JSON.parse(JSON.stringify(item))
          for (let i = item.VoteSort_temp; i < item.VoteSort; i++) {
            _this.voteInfo.VoteProjectList[i].VoteSort -= 1
            // _this.voteInfo.VoteProjectList.splice(i - 1, 1, JSON.parse(JSON.stringify(_this.voteInfo.VoteProjectList[i])))
          }
          _this.voteInfo.VoteProjectList.splice(item.VoteSort_temp - 1, 1)
          _this.voteInfo.VoteProjectList.splice(item.VoteSort - 1, 0, projectTemp)
          // _this.voteInfo.VoteProjectList = _this.sortByKey(_this.voteInfo.VoteProjectList, 'VoteSort')
        }
        if (item.VoteSort < item.VoteSort_temp) {
          const projectTemp = JSON.parse(JSON.stringify(item))
          for (let n = item.VoteSort_temp - 1; n >= item.VoteSort; n--) {
            _this.voteInfo.VoteProjectList[n - 1].VoteSort += 1
            // _this.voteInfo.VoteProjectList.splice(i, 1, JSON.parse(JSON.stringify(_this.voteInfo.VoteProjectList[i - 1])))
          }
          _this.voteInfo.VoteProjectList.splice(item.VoteSort_temp - 1, 1)
          _this.voteInfo.VoteProjectList.splice(item.VoteSort - 1, 0, projectTemp)
          // _this.voteInfo.VoteProjectList = _this.sortByKey(_this.voteInfo.VoteProjectList, 'VoteSort')
        }
      }
    },
    submitVote: function () {
      const _this = this
      _this.$confirm('确定提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'vote_message_box'
      }).then(() => {
        _this.saveVote('submit')
      }).catch(() => {

      })
    },
    saveVote: function (action) {
      const _this = this
      if (action === 'submit') {
        // 检查

      }

      // 提交参数
      const voteProjectList = []
      _this.voteInfo.VoteProjectList.forEach(projectItem => {
        const voteProject = {}
        voteProject.VoteProjectId = projectItem.VoteProjectID
        voteProject.VoteSort = projectItem.VoteSort
        voteProjectList.push(voteProject)
      })
      const param = {
        VoteId: _this.voteInfo.VoteID,
        Action: 'all_save',
        VoteProjectList: voteProjectList
      }
      if (action === 'submit') {
        param.Action = 'submit'
      }
      // 提交
      const openLoading = _this.openLoading()
      voteApi.sortVote(param).then(data => {
        if (action === 'save') {
          _this.getSortVoteInfo()
          _this.$message({
            type: 'success',
            message: '已保存'
          })
        }
        if (action === 'submit') {
          _this.getSortVoteInfo()
          _this.$message({
            type: 'success',
            message: '投票已提交'
          })
          _this.openPreview()
        }
        if (action === 'goBack') {
          this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
        }
        if (action === 'refresh') {
          _this.getSortVoteInfo()
        }
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    openPreview: function () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.voteInfoPreview = JSON.parse(JSON.stringify(_this.voteInfo))
      _this.$nextTick(() => {
        _this.votePreviewMainStyle.marginTop = (_this.$refs.mobileVotePreviewBar.offsetHeight + 45) + 'px'
      })
      _this.showPreview = true
      openLoading.close()
    },
    refreshPreview: function () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.voteInfoPreview = JSON.parse(JSON.stringify(_this.voteInfo))
      openLoading.close()
    },
    previewGoBack: function () {
      const _this = this
      if (_this.voteInfo.IsSubmit) {
        this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
      } else {
        _this.showPreview = false
      }
    },
    openResult: function () {
      this.$router.push({ name: 'result', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, voteType: 0 } })
    }
  },
  created () {
    this.getSortVoteInfo()
  }
}
</script>

<style lang="less">
@import '../../assets/css/mobileVote/vote.css';
.el-drawer__body {
  overflow: auto;
}
</style>
